export { Constants } from './constants';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/settings/index.ts